

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// getUnreadMentorRequirementNotifications
// GETUNREADMENTORREQUIREMENTNOTIFICATIONS   

const GETUNREADMENTORREQUIREMENTNOTIFICATIONS= createAsyncThunk(
  "getUnreadMentorRequirementNotifications/getUnreadMentorRequirementNotifications",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUnreadMentorRequirementNotificationsSlice = createSlice({
  name: "getUnreadMentorRequirementNotificationsSlice",
  initialState: {
    getUnreadMentorRequirementNotifications: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUnreadMentorRequirementNotifications: (state) => {
        state.getUnreadMentorRequirementNotifications.loading = false
        state.getUnreadMentorRequirementNotifications.error = false
        state.getUnreadMentorRequirementNotifications.data = []
        state.getUnreadMentorRequirementNotifications.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUNREADMENTORREQUIREMENTNOTIFICATIONS.fulfilled, (state, action) => {
      state.getUnreadMentorRequirementNotifications = {
        ...state.getUnreadMentorRequirementNotifications,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADMENTORREQUIREMENTNOTIFICATIONS.pending, (state, action) => {
      state.getUnreadMentorRequirementNotifications = {
        ...state.getUnreadMentorRequirementNotifications,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUNREADMENTORREQUIREMENTNOTIFICATIONS.rejected, (state, action) => {
      state.getUnreadMentorRequirementNotifications = {
        ...state.getUnreadMentorRequirementNotifications,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUnreadMentorRequirementNotificationsAction = {
    GETUNREADMENTORREQUIREMENTNOTIFICATIONS,
};

export { getUnreadMentorRequirementNotificationsAction };
export default getUnreadMentorRequirementNotificationsSlice.reducer;
export const {setInitialStateOfgetUnreadMentorRequirementNotifications} = getUnreadMentorRequirementNotificationsSlice.actions